import { NestAPI, useGetBusinessID } from '@marketing-milk/frontend'
import { AdCreative } from '@marketing-milk/interfaces'
import { useQuery } from 'react-query'

export const useCreativesByIds = (ids: number[]) => {
  const businessID = useGetBusinessID()

  return useQuery<AdCreative[]>(
    ['creatives-by-ids', businessID, ids],
    async () => {
      if (!ids.length) return []
      const response = await NestAPI.post<AdCreative[]>(
        `businesses/${businessID}/ad-creatives/batch`,
        { ids }
      )
      return response.data
    },
    { enabled: ids.length > 0, staleTime: 5 * 60 * 1000 }
  )
}
